export class GitPullRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "number",
            "baseName": "number",
            "type": "number",
            "format": ""
        },
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "state",
            "baseName": "state",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GitPullRequest.attributeTypeMap;
    }
    constructor() {
    }
}
